// @ts-check
import { defineStore } from "pinia";

export const useOrdersStore = defineStore("orders", {
  state: () => ({
    items: [],
    allStatuses: [],
    pagination: null,
    loading: false,
  }),
});
